<script>
import DialogCommunity from 'comp/modules/DialogModules/DialogCommunity.vue'
// import VideoCover from 'comp/common/VideoPlayer/VideoCover.vue'

import { mapGetters } from 'vuex'
import { textLenHandler, themeConfigureImgUrl, imgPathFn, imgPathEmpty, filtersRichtext } from '@/utils/common.js'
import { getCommunityIntro } from '@/api/pageData'

export default {
  components: { DialogCommunity }, // VideoCover
  data() {
    return {
      currentCommunity: localStorage.getItem('currentCommunity'),
      pageData: [],
      mapImg: '',
      currentModal: {},
      township: '', // 七里坪镇 中保镇
      village: '',
      bgMsg: '',
      leftMap: '',
      introList: [],
      titleid: 0, // 基本情况
      currentModuleItemDataId: 0,
      videoUrl: 'https://partyhelp.cdjsc.com.cn/mp4/79e182b8-8f9a-4ee3-bcee-f7f020b1feed.mp4'
    }
  },
  computed: {
    ...mapGetters({
      getCurrentNavObj: 'config/getCurrentNavObj',
      currentModalNameGetter: 'config/getCurrentModalName',
      dialogIsShowDepository: 'config/getDialogIsShow',
      screenSizeGetter: 'config/getScreenSize',
      imageCoverShow: 'coverConfig/getImageCoverShow',
      videoCoverShow: 'coverConfig/getVideoCoverShow'
    }),
    currentNavObj() {
      return this.getCurrentNavObj
    },
    currentModalName() {
      return this.currentModalNameGetter
    },
    dialogIsShow: {
      get() {
        return this.dialogIsShowDepository
      },
      set(v) {}
    },
    screenSize: {
      get() {
        return this.screenSizeGetter
      }
    },
    introListLenHandler() {
      return this.introList.length >= 5 ? this.introList.length - 4 : this.introList.length
    },
    videoCoverPlayer() {
      return this.$refs.videoCoverRef.$refs.videoCover
    }
  },
  watch: {
    screenSize(newVal, oldVal) {
      this.$nextTick(() => {
        const enlarge_dom = document.getElementById('community-intro-content')
        enlarge_dom.style.transform = `scale(${newVal})`
        enlarge_dom.style.transformOrigin = '0 0'
      })
    }
    // imageCoverShow(v) {
    //   v ? this.videoCoverPlayer.pause() : this.videoCoverPlayer.play()
    // },
    // videoCoverShow(v) {
    //   v ? this.videoCoverPlayer.pause() : this.videoCoverPlayer.play()
    // }
  },
  created() {
    this.initPageData()
  },
  methods: {
    textLenHandler, themeConfigureImgUrl, imgPathFn, imgPathEmpty, filtersRichtext,
    onCheckDetail(v) {
      if (v.memo) {
        this.currentModuleItemDataId = v.id
        this.$store.commit('config/SET_CURRENT_MODALNAME', '基本情况')
        this.$store.commit('config/SET_DIALOG', true)
      }
    },
    previewList(list) {
      return [imgPathFn(this.leftMap)]
    },

    initPageData() {
      const params = {
        village: this.currentCommunity,
        title: this.currentNavObj?.templateName || '社区简介',
        userid: localStorage.getItem('screenUserid') || 0
      }
      getCommunityIntro(params).then(res => {
        const { code, msg, township, village } = res
        if (code === 0) {
          this.township = township || ''
          this.village = village || ''

          this.introList = msg[0].list || []
          this.leftMap = msg[2]?.list[0]?.photo || ''
          this.bgMsg = msg[1]?.list[0]?.photo || ''

          msg.forEach(item => {
            if (item.title === '基本情况') this.titleid = item.titleid
          })
        }
      })
    },

    townshipClass(v, idx) {
      return v.length == 3
        ? `township-text-${idx + 1} township-text3-${idx + 1}`
        : `township-text-${idx + 1} township-text4-${idx + 1}`
    },
    introItemClass(v) {
      let idx = 1
      this.introList.forEach((item, index) => {
        if (item.headline === v.headline) idx = index
      })
      return `item-intro item-intro-${idx + 1}`
    }
  }
}
</script>

<template>
  <!-- currentNavObj.pageBg -->
  <div
    class="page-used-style community-intro"
    :style="{
      background: `url(${imgPathEmpty(bgMsg)}) no-repeat center`,
      backgroundSize: '100% 100%'
    }"
    :class="{'default-bg': !bgMsg.includes('community-bg')}"
  >
    <!-- <div class="video_box">
      <VideoCover ref="videoCoverRef" :video-url="videoUrl" :radius="30" />
    </div> -->
    <div class="enlarge-box">
      <div id="community-intro-content" class="community-intro-content">
        <div class="title-container">
          <div class="township-box">
            <div
              v-for="(v, i) in township"
              :key="`township-text-${i}`"
              :class="['township-text', townshipClass(township, i)]"
            >{{ v }}</div>
          </div>
          <div class="village-box" :class="{'township-text3-village-box': township.length === 3}">
            <div class="village-box-text village-text">{{ village }}</div>
            <div class="village-box-text welcome-text">欢迎您</div>
          </div>

          <el-image :src="require('imgs/community-intro/line.png')" alt="line" class="right-line" />
          <img
            :src="require('imgs/community-intro/retanc.png')"
            alt="retanc"
            class="right-retanc"
            :class="{'township-text3-right-retanc': township.length === 3}"
          >
        </div>
        <div class="bottom-container">
          <el-image
            class="map-img"
            :src="leftMap | imgPath"
            alt="map"
            fit="cover"
            :preview-src-list="previewList(pageData)"
          />
          <!-- 'intro-container-fa-4-len': introList.length === 4 -->
          <div
            class="intro-container-fa"
            :class="{'intro-container-beyond-4': introList.length > 4}"
          >
            <div class="intro-container">
              <div
                v-for="(v, i) in introList.slice(0, introListLenHandler)"
                :key="`intro-item-${i}`"
                class="item-container"
                @click="onCheckDetail(v)"
              >
                <div class="item-intro" :class="introItemClass(v)">{{ v.post }}</div>
                <div class="item-title">
                  <p>{{ v.headline }}</p>
                  <i v-if="v.memo" class="el-icon-arrow-right" />
                </div>
                <img
                  v-if="i + 1 !== introListLenHandler"
                  :src="require('imgs/community-intro/title-gap.png')"
                  alt="title-gap"
                  class="title-gap"
                >
              </div>
            </div>
            <div class="intro-container">
              <div
                v-for="(v, i) in introList.slice(introListLenHandler, introList.length)"
                :key="`intro-item-${i}`"
                class="item-container"
                @click="onCheckDetail(v)"
              >
                <div class="item-intro" :class="introItemClass(v)">{{ v.post }}</div>
                <div class="item-title">
                  <p>{{ v.headline }}</p>
                  <i v-if="v.memo" class="el-icon-arrow-right" />
                </div>
                <img
                  v-if="v.title !== introList[introList.length - 1].title"
                  :src="require('imgs/community-intro/title-gap.png')"
                  alt="title-gap"
                  class="title-gap"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog :dialog-is-show="dialogIsShow">
      <template #content-main>
        <DialogCommunity v-if="currentModalName" :titleid="titleid" :current-module-item-data-id="currentModuleItemDataId" />
      </template>
    </Dialog>
  </div>
</template>

<style lang="scss" scoped>
.community-intro {
  background-size: 100% 100% !important;
  position: relative;
  .video_box {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
  .enlarge-box {
    display: grid;
    place-items: center;
  }
  .community-intro-content {
    width: 1490px;
    height: 848px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all .2s ease-in;
    // overflow-y: scroll;
    // &::-webkit-scrollbar { // chrome/safari
    //   display: none;
    // }
    // scrollbar-width: none; // firefox
    // -ms-overflow-style: none; // IE10+
  }
}
.default-bg {
  border-radius: 40px;
}

.title-container {
  width: 100%;
  height: 524px;
  // border: 1px solid #000;
  // box-sizing: border-box;
  flex-shrink: 0;
  position: relative;
  .township-box {
    width: 140px;
    margin-left: 1280px;
    font-family: xiaokai;
    font-weight: 400;
    color: #16507A;
    position: relative;
    .township-text {
      // min-width: 90px;
      // min-height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .township-text-1 {
      position: absolute;
      left: 0;
      top: -70px;
      font-size: 130px;

      background-image: url('~imgs/community-intro/township-text1.webp');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .township-text-2 {
      position: absolute;
      left: 60px;
      top: 0px;
      font-size: 109px;

      background: url('~imgs/community-intro/township-text2.webp') no-repeat center;
      background-size: 100% 100%;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .township-text4-2 {
      position: absolute;
      left: 70px;
      top: 0px;
      font-size: 109px;
    }
    .township-text-3 {
      position: absolute;
      left: 20px;
      top: 70px;
      font-size: 72px;

      background: url('~imgs/community-intro/township-text3.webp') no-repeat center;
      background-size: 100% 100%;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .township-text4-3 {
      position: absolute;
      left: 10px;
      top: 40px;
      font-size: 109px;

      background: url('~imgs/community-intro/township-text3-4.webp') no-repeat center;
      background-size: 100% 100%;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .township-text-4 {
      font-size: 72px;
      position: absolute;
      left: 80px;
      top: 106px;

      background: url('~imgs/community-intro/township-text4.webp') no-repeat center;
      background-size: 100% 100%;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .village-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 192px;
    right: 15px;
    .village-box-text {
      writing-mode: vertical-lr;
      font-size: 36px;
      font-family: siyuansong;
      font-weight: 800;
      color: #4EA8D5;
      text-shadow: 0px 0px 79px rgba(0,0,0,0.14);
    }
    .village-text {
      background-image: url('~imgs/community-intro/village-text.webp');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .welcome-text {
      background-image: url('~imgs/community-intro/welcome-text.webp');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .township-text3-village-box {
    position: absolute;
    top: 152px;
    right: 55px;
  }

  .right-line {
    width: 113px;
    height: 15px;
    position: absolute;
    top: 20px;
    right: -20px;
  }
  .right-retanc {
    width: 132px;
    height: 6px;
    position: absolute;
    top: 200px;
    right: 60px;
  }
  .township-text3-right-retanc {
    position: absolute;
    top: 180px;
    right: 90px;
  }
}

.bottom-container {
  width: 1502px;
  height: 310px;
  background-color: rgba(17, 74, 105, .4);
  box-shadow: 0px 0px 21px 0px rgba(0,51,106,0.2);
  border-radius: 15px;
  margin-top: 14px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 26px;
  box-sizing: border-box;
  .map-img {
    width: 282px;
    height: 263px;
    border-radius: 10px;
  }
}
.intro-container {
  width: 1111px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 90px;
  cursor: pointer;
  .item-container {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .title-gap {
      width: 15px;
      height: 34px;
      position: absolute;
      bottom: 0;
      left: 228px;
    }
  }
  .item-intro {
    width: 200px;
    height: 54px;
    font-size: 24px;
    font-family: siyuansong;
    font-weight: 800;
    color: #fff;
    text-shadow: 0px 0px 79px rgba(0,0,0,0.14);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .item-title {
    font-size: 21px;
    font-family: siyuansong;
    font-weight: 800;
    color: #fff;
    text-shadow: 0px 0px 79px rgba(0,0,0,0.14);
    margin-top: 22px;
    display: flex;
    align-items: center;
    column-gap: 10px;
    i {
      font-size: 16px;
      margin-top: 6px;
    }
  }
  .item-intro-1, .item-intro-6 {
    background: url('~imgs/community-intro/module-bg1.png') no-repeat center;
    background-size: 100% 100%;
  }
  .item-intro-2, .item-intro-7 {
    background: url('~imgs/community-intro/module-bg2.png') no-repeat center;
    background-size: 100% 100%;
  }
  .item-intro-3, .item-intro-8 {
    background: url('~imgs/community-intro/module-bg3.png') no-repeat center;
    background-size: 100% 100%;
  }
  .item-intro-4 {
    background: url('~imgs/community-intro/module-bg4.png') no-repeat center;
    background-size: 100% 100%;
  }
  .item-intro-5 {
    background: url('~imgs/community-intro/module-bg5.png') no-repeat center;
    background-size: 100% 100%;
  }
}
.item-container-second-line {
  position: relative;
  .title-gap {
    width: 15px;
    height: 34px;
    position: absolute;
    bottom: 0;
    left: 228px;
  }
}
.intro-container-fa {
  width: 1111px;
  height: 263px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.intro-container-fa-4-len {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.intro-container-beyond-4 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
